import Service from "./service"
import Search from "../../../assets/search.webp"
import Cloud from "../../../assets/cloud.webp"
import Team from "../../../assets/team.webp"
import Dev from "../../../assets/dev.webp"
import Addition1 from "../../../assets/addition1.webp"
import Addition2 from "../../../assets/addition2.webp"

const AdditionalServices = () => {
    return (
        <div className="additional-services-container">
            <div className="details">
                <div className="dash"></div>
                <h3>Additional Services We Provide</h3>
            </div>
            <div className="additional-services-container">
                <div className="additional-services">
                    <Service img={Search} title="Product Discovery" desc="Our Product Discovery service aligns your product's direction with the real demands of the market, guaranteeing that your development journey is not just strategic but also genuinely impactful. " />

                    <Service img={Cloud} title="Cloud Migration and Management" desc="We help businesses migrate their applications and data to the cloud, ensuring that they are secure, scalable, and cost-effective" />

                    <Service img={Team} title="Outsourced Development Teams" desc="We provide dedicated development teams consisting of highly skilled software developers, DevOps engineers, QA specialists, UX designers, project managers, and others, that work exclusively on your projects, ensuring that you have access to the best talent and expertise." />

                    <Service img={Dev} title="Dev Team Augmentation" desc="We offer IT Staff Augmentation services that help businesses expand their team’s talent pool as needed. Our IT Staff Augmentation services are available on an hourly basis, and you can start and finish their involvement as you need, saving on keeping full-time employees in-house." />
                </div>
                <div className="addition">
                    <img className="one" src={Addition1} alt="Service" />
                    <img className="two" src={Addition2} alt="Service" />
                    {/* <img className="three" src={""} alt="Service" /> */}
                </div>
            </div>
        </div>
    )
}

export default AdditionalServices;